import $ from 'cash-dom';
import DeviceSizes from '../../../components/DeviceSizes';

let instance = null;

class TipSection {
	constructor() {
		if (!instance) {
			this._$vendorsList = $('.vendors-list');
			this._$tipSections = $('.tip-section-container');
			this._isMobile = window.innerWidth < DeviceSizes.MD;
			this._showOnMobile = !!$('#tipSectionShowOnMobile').val();

			const defaultTipSectionIndex = $('#tipSectionIndex').val();
			this._defaultTipSectionIndex = isNaN(defaultTipSectionIndex) ? 2 : +defaultTipSectionIndex;

			instance = this;
		}

		return instance;
	}

	static getInstance() {
		if (!TipSection._instance) {
			TipSection._instance = new TipSection();
		}

		return TipSection._instance;
	}

	init() {
		this._showNeededTipSection();

		$(document).on('filters-change', () => {
			this._showNeededTipSection();
		});
	}

	_showNeededTipSection() {
		this._$tipSections.hide();
		$('.tip-section-clone').remove();

		// don't show tip section for mobile
		if (this._isMobile && !this._showOnMobile) {
			return;
		}

		const $visibleVendors = this._$vendorsList.find('.ppc-single-vendor').not('.hidden');
		const visibleVendorsLength = $visibleVendors.length;

		let index = null;
		//TODO: tip from first visible vendor inserted after vendor with needed index. is it right logic? we have all tips on page, so we can just show/hide them (add 'hidden' class to tips for pages that have filters)
		if (visibleVendorsLength >= 3) {
			index = this._defaultTipSectionIndex;
		} else if (visibleVendorsLength) {
			index = visibleVendorsLength - 1;
		}

		const $visibleVendor = $($visibleVendors.get(index));

		if ($visibleVendor.length) {
			const $firstVisibleVendor = $($visibleVendors.get(0));
			const $firstTipSection = $firstVisibleVendor.next('.tip-section-container').clone();

			if ($firstTipSection.length) {
				$firstTipSection.addClass('tip-section-clone').css('display', 'flex');
				$visibleVendor.after($firstTipSection);
			}
		}

		this._$tipSections.filter('.always-show').each(function () {
			const $origTip = $(this);
			$origTip.after(
				$origTip.clone()
					.addClass('tip-section-clone')
					.css('display', 'flex')
			);
		});
	}
}

export default TipSection;
